import { isSafeKey } from '@/utils/security';

export default {
  getValidMeta: state => {
    const meta = {};
    // Use forEach instead of map for side effects
    Object.entries(state.changed).forEach(([key, value]) => {
      if (value.valid && isSafeKey(key)) {
        meta[key] = value;
      }
    });
    return meta;
  },
  getOldValue: state => key => {
    const value = Object.values(state.changed).filter(x => x.variable === key || x.validRef === key);
    if (Array.isArray(value) && value.length > 0) {
      return value[0];
    }
    return null;
  }
};
